// removed by extract-text-webpack-plugin
module.exports = {"bp":"(min-width: 700px)","darkGradient":"radial-gradient(#002A3B 0%, #00171F 94.96%)","dark":"#00171F","black":"#000000","tblue":"undefined","gray":"#EFEFEF","blue":"#00A8E8","wrapper":"src-components-IconGrid----IconGrid-module---wrapper---2T1A6","heading":"src-components-IconGrid----IconGrid-module---heading---1Y62o","itemHeading":"src-components-IconGrid----IconGrid-module---itemHeading---HmDmd","items":"src-components-IconGrid----IconGrid-module---items---Cr34w"};


//////////////////
// WEBPACK FOOTER
// ./src/components/IconGrid/IconGrid.module.css
// module id = 205
// module chunks = 35783957827783 129448336650289